export default __webpack_public_path__ + "static/media/machine.182442c2.svg";